<h4 mat-dialog-title>
  <span *ngIf="!data;else editHeader">
    Creazione nuova zona geografica
  </span>
  <ng-template #editHeader>
    Modifica zona geografica {{data.nome}}
  </ng-template>
</h4>
<form *ngIf="form" [formGroup]="form" class="mt-4" (keydown.enter)="edit()">

  <mat-form-field>
    <mat-label>Nome</mat-label>
    <input matInput formControlName="nome">
    <mat-icon matSuffix>nome</mat-icon>
  </mat-form-field>

  <mat-form-field>

    <mat-label>
      Descrizione
    </mat-label>
    <input matInput formControlName="descrizione">
  </mat-form-field>

</form>
<button mat-raised-button (click)="edit()" color="primary">Salva</button>